const r=r=>Array.isArray(r)&&"number"==typeof r[0];export{r as isBezierDefinition};
